import React, { useState,useEffect } from "react";
import { 
  useGetiqmahannouncementQuery, 
  useIqamahannouncementMutation 
} from "../../../store/Reducer/annocements";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const IqamahAnnouncements = () => {
  const { t } = useTranslation();
  
  const {
    data: annocementsdata,
    isLoading,
    error,
  } = useGetiqmahannouncementQuery();

  const [iqamahannouncement, { isLoading: createIqmahloading }] = useIqamahannouncementMutation();

  const [formData, setFormData] = useState({
    fajr: false,
    dhuhr: false,
    asr: false,
    maghrib: false,
    isha: false,
  });

  useEffect(() => {
    if (annocementsdata?.data) {
      setFormData({
        fajr: annocementsdata?.data?.fajr || false,
        dhuhr: annocementsdata?.data?.dhuhr || false,
        asr: annocementsdata?.data?.asr || false,
        maghrib: annocementsdata?.data?.maghrib || false,
        isha: annocementsdata?.data?.isha || false,
      });
    }
  }, [annocementsdata]);
  

  const namazList = [
    { label: t("fajr"), value: "fajr" },
    { label: t("dhuhr"), value: "dhuhr" },
    { label: t("asr"), value: "asr" },
    { label: t("maghrib"), value: "maghrib" },
    { label: t("isha"), value: "isha" },
  ];

  // Handle checkbox change
  const handleCheckboxChange = async (e) => {
    const { name, checked } = e.target;
    const updatedFormData = {
      ...formData,
      [name]: checked,
    };
    setFormData(updatedFormData);
    
    await changeAnnouncement(updatedFormData);
  };

  const changeAnnouncement = async (data) => {
    try {
      const response = await iqamahannouncement(data).unwrap();
      toast.success(response?.message || "Announcement updated successfully");
    } catch (err) {
      console.error("Submission failed", err);
      toast.error(err?.data?.message || "An error occurred while updating the announcement");
    }
  };

  return (
    <>
      <div className="content mt-6">
        {isLoading || createIqmahloading ? (
          <div className="pt-16 flex justify-center mt-12 items-center">
            <div
              className="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-gray-700 dark:text-gray-100 rounded-full"
              role="status"
              aria-label="loading"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="mb-2 ">
            <p className="py-3 px-3 text-sm rounded-lg border border-blue-200 bg-blue-50 text-blue-800">
              When you change a prayer's Iqamah, your website and screens show it for 24 hours with that day's time,
              for example "Isha Iqamah is now 7:30 pm". Turn off the prayers you don't want announced.
            </p>
            <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-1">
              {namazList.map(({ label, value }) => (
                <div
                  key={value}
                  className="namazTime pb-3 border-b border-gray-400 flex justify-between items-center"
                >
                  <h4 className="text-lg font-normal">
                    {label.charAt(0).toUpperCase() + label.slice(1)}
                  </h4>
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      name={value}
                      checked={formData[value]}
                      onChange={handleCheckboxChange}
                      aria-label={`Announce ${label} Iqamah changes`}
                      className="sr-only peer"
                    />
                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default IqamahAnnouncements;
